module.exports = __webpack_public_path__ + "img/house2.1029fc76.jpg";